import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import './style.css';

class Loader extends React.Component {
  render() {
    return (
      <Grid container-fluid='true'>
        <Card align='right'>
          <Grid item>
            <div className='loader-container'>
              <div className='loader'>
                <div className='box' id='box-1' />
                <div className='box' id='box-2' />
                <div className='box' id='box-3' />
                <div className='box' id='box-4' />
              </div>
            </div>
          </Grid>
        </Card>
      </Grid>
    );
  }
}

export default Loader;
